export const THEMES_ROUTING = [
  {
    path: '/theme/:theme',
    name: 'theme',
    component: () =>
      import(/* webpackChunkName: "theme-page" */ './pages/theme/theme.page'),
    alias: []
  }
];
